import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    getAllUser: [],
    loading: false,
    error: null,
}

const getAllUserSlice = createSlice({
    name: "getAllUser",
    initialState,
    reducers: {
        fetchGetAllUserSuccess: (state, action) => {
            state.loading = false;
            state.getAllUser = action.payload;
        },
        fetchGetAllUserFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchGetAllUserSuccess,fetchGetAllUserFailure } = getAllUserSlice.actions;

export default getAllUserSlice.reducer;
